<template>
  <v-app id="" >
    <v-content>
      <v-container
        fluid
        fill-height
        class="login-container"
      >
        <v-layout
          align-center
          justify-center
        >
              <v-card style="min-height:300px;max-width:80%" elevation="8"
              >
                <v-img
                            src="/img/bfbk.jpg"
                            class="pa-5 white--text align-center"
                            height="200px"
                >
                <v-card-title class="font-weight-black text-h4">THHS | Dash</v-card-title>
                </v-img>
                <v-card-text class="text-align-center" align-center justify-center>
                  <v-card-subtitle style="padding-top:0px;color:black">Login with your @townsendharris.org account</v-card-subtitle>
                  <v-btn
                    large
                    @click="gmailLogin"
                  >
                    <v-icon left>mdi-account</v-icon>
                    @townsendharris.org
                  </v-btn>
                </v-card-text>
              </v-card>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<style>
</style>

<script>
import router from '../router'
const fb = require('../firebaseConfig.js')
var firebase = require('firebase')

export default {
  props: {
  },
  data: () => ({
    alert: {
      type: null,
      msg: '',
      show: false
    },
    email: null,
    password: null,
    drawer: null,
    showPW: false,
    showReset: false,
    showResetBtn: true,
    loggingIn: false
  }),
  watch: {
    '$route' (to, from) {
      this.checkWarnings()
    }
  },
  mounted () {
    this.checkWarnings()
  },
  methods: {
    showResetForm () {
      this.showReset = true
      this.showResetBtn = true
    },
    gmailLogin () {
      var provider = new firebase.auth.GoogleAuthProvider()
      provider.setCustomParameters({
        // Forces account selection even when one account
        // is available.
        hd: 'townsendharris.org'
      })
      firebase.auth().signInWithPopup(provider).then(function (result) {
        // This gives you a Google Access Token. You can use it to access the Google API.
        // var token = result.credential.accessToken
        // The signed-in user info.
        var user = result.user
        console.log(user)
        router.push('/home')
        // ...
      }).catch(function (error) {
        console.log(error)
        // Handle Errors here.
        // var errorCode = error.code
        // var errorMessage = error.message
        // The email of the user's account used.
        // var email = error.email
        // The firebase.auth.AuthCredential type that was used.
        // var credential = error.credential
        // ...
      })
    },
    reset () {
      var self = this
      fb.auth.sendPasswordResetEmail(self.email).then(function () {
        self.alert.type = 'success'
        self.alert.msg = 'An email was sent to the address provided to reset your password'
        self.alert.show = true
        self.showResetBtn = false
      })
    },
    checkWarnings () {
      var self = this
      let query = this.$route.query
      console.log(query)
      if (query.disabled) {
        self.alert.type = 'warning'
        self.alert.msg = 'This account is disabled. Please contact your admin to restore access.'
      }
    },
    login (event) {
      var self = this
      var email = this.email
      var password = this.password
      this.loggingIn = true
      fb.auth.signInWithEmailAndPassword(email, password)
        .then(function (credentials) {
          console.log('successfully signed in with email pw', credentials)
          self.loggingIn = false
          router.push('/home')
        })
        .catch(function (error) {
          // Handle Errors here.
          var errorCode = error.code
          var errorMessage = error.message
          if (errorCode === 'auth/wrong-password') {
            self.alert.type = 'error'
            self.alert.msg = 'invalid account/password'
            self.alert.show = true
            self.loggingIn = false
          } else {
            alert(errorMessage)
          }
          console.log(error)
        })
    }
  }
}
</script>
